export enum EndPoint {
  LOGIN = 'login',
  PERSONA="persona",
  ARTICULO="articulo",
  LOCALIDAD="localidad",
  LOCARTICULO="localidadarticulo",
  TURNOCAJA="caja",
  MOVIMIENTOCAJA="cajadetalle",
  OFERTAVENTA="ofertaventa",
  RESERVA="reserva"
}
